<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('driverAdd.title') }}</h1>
          <hr />
          <driver-form />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import DriverForm from '@/components/driver/DriverForm.vue';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    if (hasPermission('driver_add')) next();
    if (from.name !== 'drivers-list') next({ name: 'drivers-list' });
  },
  name: 'AddDriverPage',
  components: {
    DriverForm,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
h1 {
  margin-bottom: 15px;
}
</style>
